import React from 'react';
import styles from './styles.module.scss';
import PageContent from 'src/Components/PageContent';
import Spinner from 'src/Components/Spinner';
import EmptyList from 'src/Components/EmptyList';
import StakingItem from './Components/StakingItem';
import StakingProvider from './StakingProvider';
import { useTypedDispatch, useTypedSelector } from 'src/redux/utils';
import { fetchMyStaking } from 'src/redux/actions';
import { AppError } from 'src/redux/types';
import withScrollToTop from 'src/utils/withScrollToTop';
import UserWalletProvider from '@profile/src/Profile_V2/UserWalletProvider';
import Summary from './Components/Summary';

const YourStaking = () => {
  const dispatch = useTypedDispatch();
  const myStaking = useTypedSelector(state => state.myStaking.data);
  const summary = useTypedSelector(state => state.myStaking.summary);
  const error = useTypedSelector(state => state.myStaking.error);
  const loading = useTypedSelector(state => state.myStaking.loading);
  const invalidated = useTypedSelector(state => state.myStaking.invalidated);
  const apr = useTypedSelector(state => state.estimateApr.data);
  const signedIn = useTypedSelector(state => !!state.userProfile.user);
  const stakingConfig = useTypedSelector(state => state.stakingConfig.data);
  React.useEffect(() => {
    dispatch(fetchMyStaking());
  }, []);

  const renderContent = () => {
    return /*#__PURE__*/React.createElement("div", {
      className: styles.container
    }, /*#__PURE__*/React.createElement("span", {
      className: styles.title
    }, "Rewards Summary"), /*#__PURE__*/React.createElement(Summary, {
      className: styles.summary,
      summary: summary
    }), myStaking.map(data => stakingConfig && /*#__PURE__*/React.createElement(StakingItem, {
      config: stakingConfig,
      item: data,
      key: data.id,
      apr: apr
    })));
  };

  const renderError = () => {
    return /*#__PURE__*/React.createElement(EmptyList, {
      title: "Sorry, something went wrong.",
      content: "Please try again.",
      className: styles.empty
    });
  };

  const renderLoading = () => {
    return /*#__PURE__*/React.createElement(Spinner, {
      className: styles.spinner
    });
  };

  return /*#__PURE__*/React.createElement(UserWalletProvider, null, /*#__PURE__*/React.createElement(StakingProvider, null, /*#__PURE__*/React.createElement("div", {
    className: styles.root
  }, /*#__PURE__*/React.createElement(PageContent, {
    renderContent: renderContent,
    renderLoading: renderLoading,
    renderError: renderError,
    error: signedIn && error !== AppError.NO_ERROR,
    loading: signedIn && loading,
    invalidated: signedIn && invalidated
  }))));
};

export default withScrollToTop(YourStaking);